import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';

export interface TagDetailsForm {
  fieldName: string;
}

export interface TagDetails {
  _id: string;
  fieldName: string;
  ghlSynced?: boolean;
  ghlWarning?: string;
}

export const createTagAPI = async (tagDetails: TagDetailsForm) => {
  const resp = await baseAPI.post<TagDetails>('tags', tagDetails);
  return resp.data;
};

export const useCreateTagMutation = () => {
  return useMutation({
    mutationFn: async (tagDetails: TagDetailsForm) => {
      const response = await createTagAPI(tagDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['tags'],
      });
    },
  });
};
